<!-- 关于我们 -->
<template>

  <div class="joinbox">
    <Header></Header>
    <div class="banxin">
      <div class="title_tab">
        <p @click="istab = 1" :class="istab == 1 ? 'active' : ''">主播招募</p>
        <p @click="istab = 2" :class="istab == 2 ? 'active' : ''">公会招募</p>
        <p @click="istab = 3" :class="istab == 3 ? 'active' : ''">我们的优势</p>
      </div>
      <div class="content">
        <div class="bg1" v-if="istab == 1">
          <div class="erweima">
            <h5 class="title"></h5>
            <div class="mabox">
              <div>
                <img src="https://resource.imbeiyu.com/gw/assets/images/web/ercode2.png" alt="">
                <p>微信:nnzb_cat</p>
              </div>
              <!-- <div>
                        <img src="https://resource.imbeiyu.com/gw/assets/images/web/pic_code_2.png" alt="">
                        <p>微信:ynb2712</p>
                    </div> -->
            </div>
          </div>
          <div class="imgs">
            <img src="https://resource.imbeiyu.com/gw/assets/images/web/pic_rule1.png" alt="">
            <img src="https://resource.imbeiyu.com/gw/assets/images/web/pic_rule2.png" alt="">
            <img src="https://resource.imbeiyu.com/gw/assets/images/web/pic_rule3.png" alt="">
            <img src="https://resource.imbeiyu.com/gw/assets/images/web/pic_rule4.png" alt="">
            <img src="https://resource.imbeiyu.com/gw/assets/images/web/pic_rule5.png" alt="">
            <img src="https://resource.imbeiyu.com/gw/assets/images/web/pic_rule6.png" alt="">
          </div>
        </div>
        <div class="bg2" v-else-if="istab == 2">
          <!-- <div class="erweima">
            <h5 class="title"></h5>
            <div class="mabox">
              <div>
                <img src="https://resource.imbeiyu.com/gw/assets/images/web/ercode1.jpg" alt="">
                <p>微信:nnzb_jiazu</p>
              </div>

            </div>
          </div> -->
        </div>

        <div class="bg3" v-else-if="istab == 3">
          <ul>
            <li><img src="https://resource.imbeiyu.com/gw/assets/images/web/pic_we1.png" alt=""></li>
            <li><img src="https://resource.imbeiyu.com/gw/assets/images/web/pic_we2.png" alt=""></li>
            <li><img src="https://resource.imbeiyu.com/gw/assets/images/web/pic_we3.png" alt=""></li>
            <li><img src="https://resource.imbeiyu.com/gw/assets/images/web/pic_we4.png" alt=""></li>
            <li><img src="https://resource.imbeiyu.com/gw/assets/images/web/pic_we5.png" alt=""></li>
            <li><img src="https://resource.imbeiyu.com/gw/assets/images/web/pic_we6.png" alt=""></li>
          </ul>
        </div>

      </div>

    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from "../../components/header"
import Footer from "../../components/footer"
export default {
  components: {
    Header, Footer
  },
  data() {
    return {
      istab: 1
    }
  },
  created() {

  },
  methods: {

  },
}
</script>
<style lang="less" scoped>
.joinbox {
  background: rgba(250, 250, 250, 1);
}

.title_tab {
  display: flex;
  height: .4rem;
  align-items: center;

  p {
    margin-right: .2rem;
    font-size: 0.11rem;
    font-weight: 600;
    color: rgba(153, 153, 153, 1);
    cursor: pointer;
  }

  .active {
    color: rgba(51, 51, 51, 1);
    position: relative;
  }

  .active::after {
    content: "";
    position: absolute;
    bottom: -.06rem;
    left: 50%;
    transform: translateX(-50%);
    width: 0.2rem;
    height: 0.02rem;
    background: rgba(255, 32, 94, 1);
    border-radius: 0.01rem;
  }
}

.content {
  background: rgba(255, 255, 255, 1);
  height: 4.2rem;

  .bg1 {
    background: url('https://resource.imbeiyu.com/gw/assets/images/web/bg1.png');
    background-size: 100% 100%;
    width: 100%;
    border-radius: .1rem;
    height: 100%;
    position: relative;

    .erweima {
      position: absolute;
      right: .6rem;
      top: 1rem;
      width: 1.9rem;

      .title {
        background: url('https://resource.imbeiyu.com/gw/assets/images/web/title_contact1.png');
        background-size: 100% 100%;
        height: .14rem;
        width: 1.9rem;

      }

      .mabox {
        width: 100%;
        display: flex;
        justify-content: center;

        div {
          margin-top: .13rem;
          width: 40%;
          display: flex;
          flex-direction: column;

          img {
            width: 100%;
            height: auto;
          }

          p {
            margin-top: .05rem;
            width: 100%;
            text-align: center;
            font-size: .08rem;
            color: #fff;
          }
        }

      }
    }

    @keyframes ani0 {
      0% {
        width: 90%;
        opacity: .5;
      }

      //  50%{opacity:.8; }
      100% {
        width: 100%;
        opacity: 1;
      }
    }

    .imgs {
      width: 100%;
      position: absolute;
      bottom: .2rem;
      display: flex;
      padding: 0 .3rem;
      box-sizing: border-box;
      animation: ani0 1s;

      img {
        width: .9rem;
        height: 1.3rem;
        animation: ani1 1s;
        margin-left: .1rem;
      }

      img:hover {
        box-shadow: 0 0 4Px 2Px #ffb537;
      }


      @keyframes ani1 {
        0% {
          transform: translateX(-10%);
          transform: translateY(-10%);
          margin-left: 0rem;
        }

        //  50%{opacity:.8; }
        100% {
          transform: translateX(0);
          transform: translateY(0);
          margin-left: .1rem;
        }
      }
    }
  }

  .bg2 {
    background: url('https://resource.imbeiyu.com/nnxqGw/img/bg2.png');
    position: relative;
    background-size: 100% 100%;
    width: 100%;
    border-radius: .1rem;
    height: 100%;

    .erweima {
      position: absolute;
      right: .6rem;
      top: 1rem;
      width: 1.9rem;

      .title {
        background: url('https://resource.imbeiyu.com/gw/assets/images/web/title_contact2.png');
        background-size: 100% 100%;
        height: .14rem;
        width: 1.9rem;

      }

      .mabox {
        width: 100%;
        display: flex;
        justify-content: center;

        div {
          margin-top: .13rem;
          width: 40%;
          display: flex;
          flex-direction: column;

          img {
            width: 100%;
            height: auto;
          }

          p {
            margin-top: .05rem;
            width: 100%;
            text-align: center;
            font-size: .08rem;
            color: #fff;
          }
        }

      }
    }
  }

  .bg3 {
    width: 100%;
    height: 100%;

    ul {
      padding: .3rem .2rem;
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      li {
        width: 30%;
        animation: ani2 1s;

        img {
          width: 100%;
          height: auto;
        }

        @keyframes ani2 {
          0% {
            opacity: 0;
            transform: translateY(-4%)
          }

          //  50%{opacity:.8; }
          100% {
            opacity: 1;
            transform: translateY(0)
          }
        }
      }

      li:hover {

        img {
          opacity: .9;
          box-shadow: 0 0 10Px 5Px #fff;
        }




      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/page/webpage/pcenlist.vue